module.exports = __webpack_public_path__ + "media/newstyle/images/icon-trash-can-dfc1ebc0a4657ce7eee0a23684f84ae0.svg";